import React from "react";
import { Delete } from "@mui/icons-material";
import RestoreFromTrashIcon from "@mui/icons-material/RestoreFromTrash";
import EmailIcon from "@mui/icons-material/Email";
import GroupsIcon from "@mui/icons-material/Groups";
import PersonRemoveIcon from "@mui/icons-material/PersonRemove";
import type {
  BulkActionDescriptor,
  BulkActionsSlot,
  BulkActionsSlotContext,
} from "@/components/tables/toolbar/bulkActionsSlot";

type SelectedUser = Record<string, any>;
type UserBulkRequest = (
  selectedUsers: SelectedUser[],
  table: BulkActionsSlotContext
) => void;

export interface UserBulkActionOptions {
  t: (key: string) => string;
  subdomain: string;
  deletePeople: UserBulkRequest;
  undeletePeople: UserBulkRequest;
  sendRegistrationMails: UserBulkRequest;
  addToDepartments: (selectedUsers: SelectedUser[]) => void;
  moveToCompany: (
    selectedUsers: SelectedUser[],
    table: BulkActionsSlotContext
  ) => void;
}

export const userBulkActions =
  (options: UserBulkActionOptions): BulkActionsSlot =>
  (selectedUsers, table) => {
    const { t } = options;
    const actions: BulkActionDescriptor[] = [
      {
        key: "delete",
        label: t("delete"),
        tooltip: t("delete_selected_users"),
        icon: <Delete />,
        color: "error",
        onClick: () => options.deletePeople(selectedUsers, table),
      },
    ];

    if (selectedUsers.every((user) => user.is_deleted)) {
      actions.push({
        key: "restore",
        label: t("restore"),
        tooltip: t("undelete_selected_users"),
        icon: <RestoreFromTrashIcon />,
        onClick: () => options.undeletePeople(selectedUsers, table),
      });
    }

    if (selectedUsers.every((user) => !user.is_deleted)) {
      actions.push(
        {
          key: "sendRegistrationMails",
          label: t("send_email"),
          tooltip: t(
            "send_registration_or_passwordreset_email_to_selected_users"
          ),
          icon: <EmailIcon />,
          disabled: selectedUsers.some((user) => user.is_analog),
          onClick: () => options.sendRegistrationMails(selectedUsers, table),
        },
        {
          key: "addToDepartments",
          label: t("add_department"),
          tooltip: t("add_selected_users_to_department"),
          icon: <GroupsIcon />,
          onClick: () => options.addToDepartments(selectedUsers),
        }
      );
      if (options.subdomain === "admin") {
        actions.push({
          key: "moveToCompany",
          label: t("move_to_comapny"),
          tooltip: t("move_selected_users_to_another_company"),
          icon: <PersonRemoveIcon />,
          onClick: () => options.moveToCompany(selectedUsers, table),
        });
      }
    }

    return actions;
  };
